/**
 * @generated SignedSource<<f1c06211d1bb34041513105950c28a11>>
 * @relayHash 5f51a4275168e0ee428e5da3f7a7cd6a
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5f51a4275168e0ee428e5da3f7a7cd6a

import { ConcreteRequest } from 'relay-runtime';
export type BioV2VisitorCanEditQuery$variables = Record<PropertyKey, never>;
export type BioV2VisitorCanEditQuery$data = {
  readonly visitor: {
    readonly userAccount: {
      readonly contraMagicBioSuggestions: ReadonlyArray<{
        readonly id: string;
        readonly isSelected: boolean;
        readonly suggestion: string;
      }> | null;
      readonly contraMagicQuestionnaireResponse: {
        readonly whatMakesYouUnique: string;
        readonly whatServicesDoYouOffer: string;
      } | null;
    } | null;
  };
};
export type BioV2VisitorCanEditQuery = {
  response: BioV2VisitorCanEditQuery$data;
  variables: BioV2VisitorCanEditQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "ContraMagicSuggestion",
  "kind": "LinkedField",
  "name": "contraMagicBioSuggestions",
  "plural": true,
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSelected",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "suggestion",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "ContraMagicQuestionnaireResponse",
  "kind": "LinkedField",
  "name": "contraMagicQuestionnaireResponse",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "whatMakesYouUnique",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "whatServicesDoYouOffer",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "BioV2VisitorCanEditQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Visitor",
        "kind": "LinkedField",
        "name": "visitor",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserAccount",
            "kind": "LinkedField",
            "name": "userAccount",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "BioV2VisitorCanEditQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Visitor",
        "kind": "LinkedField",
        "name": "visitor",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserAccount",
            "kind": "LinkedField",
            "name": "userAccount",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v0/*: any*/)
            ],
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "5f51a4275168e0ee428e5da3f7a7cd6a",
    "metadata": {},
    "name": "BioV2VisitorCanEditQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "dd1dc06f6b7df6b2ecd4abc304b81d3d";

export default node;
